import { render, staticRenderFns } from "./FormWizardNumber.vue?vue&type=template&id=5814b950"
import script from "./FormWizardNumber.vue?vue&type=script&lang=js"
export * from "./FormWizardNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports